<template>
  <ul class="sidebar">
    <!-- 智能客服 -->
    <li class="sidebar-item">
      <div class="sidebar-shadow">
        <svg
          class="icon static-icon"
          aria-hidden="true"
        >
          <use xlink:href="#icon-kefu"></use>
        </svg>
        <svg
          class="icon hover-icon"
          aria-hidden="true"
        >
          <use xlink:href="#icon-kefu2"></use>
        </svg>
      </div>
      <div class="wrapper">
        <div class="additional-box">
          <p class="additional-title">{{ $t('在线咨询') }}</p>
          <p
            class="additional-text"
            @click="handleGoService"
          >
            <a>{{ $t('智能客服在线解答') }}</a>
          </p>
        </div>
      </div>
    </li>
    <!-- 电话 -->
    <li class="sidebar-item">
      <div class="sidebar-shadow">
        <svg
          class="icon static-icon"
          aria-hidden="true"
        >
          <use xlink:href="#icon-dianhua"></use>
        </svg>
        <svg
          class="icon hover-icon"
          aria-hidden="true"
        >
          <use xlink:href="#icon-dianhua2"></use>
        </svg>
      </div>
      <div class="wrapper">
        <div class="additional-box">
          <p class="additional-title">{{ $t('客服电话') }}</p>
          <p class="additional-text tel">
            <a href="tel:400-022-9291">400-022-9291</a>
          </p>
          <p class="additional-title">{{ $t('工作时间') }}</p>
          <p class="additional-text">{{ $t('周一至周五') }} 9:00-18:00</p>
        </div>
      </div>
    </li>
    <!-- 邮箱 -->
    <li class="sidebar-item">
      <div class="sidebar-shadow">
        <svg
          class="icon static-icon"
          aria-hidden="true"
        >
          <use xlink:href="#icon-youxiang"></use>
        </svg>
        <svg
          class="icon hover-icon"
          aria-hidden="true"
        >
          <use xlink:href="#icon-youxiang2"></use>
        </svg>
      </div>
      <div class="wrapper">
        <div class="additional-box">
          <p class="additional-title">{{ $t('联系邮箱') }}</p>
          <p class="additional-text">
            <a href="mailto:support@cbibank.com">support@cbibank.com</a>
          </p>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    handleGoService () {
      window.open('https://13693056940.ewei.com/client/?provider_id=25787&uid=63sfoTfPYyhGgGa8TxBx1aOdJ2VV0zIS', '_blank')
    }
  }
}
</script>

<style scoped lang="less">
.sidebar {
  position: fixed;
  right: 30px;
  bottom: 250px;
  width: 50px;
  // height: 152px;
  background: #ffffff;
  box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 25px;
  z-index: 999;

  .sidebar-item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    line-height: 50px;
    text-align: center;

    .sidebar-shadow {
      width: 38px;
      height: 38px;
      line-height: 40px;
      text-align: center;
      border-radius: 19px;
      background: #fff;
    }

    .icon {
      width: 20px;
      height: 20px;
    }

    .static-icon {
      display: inline-block;
    }

    .hover-icon {
      display: none;
    }
    .wrapper {
      position: absolute;
      top: 50%;
      transform: translate(-100%, -50%);
      left: 0;
      padding-right: 20px;
      .additional-box {
        position: relative;
        display: none;
        padding: 16px 20px;
        background: #fff;
        text-align: left;
        font-weight: 400;
        border-radius: 4px;
        white-space: nowrap;

        .additional-title {
          font-size: 14px;
          color: #5a607f;
          line-height: 14px;
          margin-bottom: 10px;
        }

        .additional-text {
          font-size: 12px;
          color: #a1a7c4;
          line-height: 12px;
          &.tel {
            margin-bottom: 16px;
          }
          > a {
            font-size: 12px;
            color: #4a6aff;
            line-height: 12px;
            cursor: pointer;
          }
        }

        &::after {
          position: absolute;
          right: -9px;
          top: 50%;
          transform: translate(0, -50%) rotate(45deg);
          content: '';
          width: 18px;
          height: 18px;

          background: #fff;
          background-size: 16px 16px;
          border-top-right-radius: 3px;
        }
      }
    }

    &:hover {
      .sidebar-shadow {
        background: #f6f7fc;
      }

      .static-icon {
        display: none;
      }

      .hover-icon {
        display: inline-block;
      }

      .additional-box {
        display: block;
        animation-name: fadeIn;
        animation-duration: 1s;
      }
    }
    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    @keyframes fadeOut {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }

    &::after {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      content: '';
      width: 20px;
      height: 1px;
      background: #e6e9f4;
    }

    &:last-child {
      &::after {
        display: none;
      }
    }
  }
}
</style>
